import { render, staticRenderFns } from "./ReactionPicker.vue?vue&type=template&id=5d9fea8c&scoped=true"
import script from "./ReactionPicker.vue?vue&type=script&lang=js"
export * from "./ReactionPicker.vue?vue&type=script&lang=js"
import style0 from "./ReactionPicker.vue?vue&type=style&index=0&id=5d9fea8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fea8c",
  null
  
)

export default component.exports